export const getDateWithoutTime = (date: Date | string) => {
  if (typeof date === 'string') {
    const dateObj = new Date(date);
    return new Date(
      dateObj.getFullYear(),
      dateObj.getMonth(),
      dateObj.getDate(),
    );
  }

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
